import { JRCAvatar } from 'components/JRCAvatar/JRCAvatar';
import { JRCIcon } from 'components/JRCIcon/JRCIcon';
import { JRCPagination } from 'components/JRCPagination/JRCPagination';
import { JRCTooltip } from 'components/JRCTooltip/JRCTooltip';
import { WidgetQuickSurveyResponseUserList } from 'jamespot-user-api';
import React, { useCallback } from 'react';
import styled from 'styled-components';
import { JRCModalContent } from '../JRCModal/JRCModalContent';
import { JRCModalLayout } from '../JRCModal/JRCModalLayout';

export type JRCModalUserListProps = {
    open: boolean;
    usersList?: WidgetQuickSurveyResponseUserList;
    title: string;
    handleLoadUsersList: (page: number) => void;
    setOpen: (open: boolean) => void;
    onClose: () => void;
};

const CSSUserList = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0px ${({ theme }) => theme.space.md};
    gap: 8px;
`;

const CSSUserItem = styled.a`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px;
    cursor: pointer;

    &:hover {
        background-color: ${(props) => props.theme.color.grey1};
    }
`;

export const CSSAvatarWrapper = styled.div<{ overlap?: boolean }>`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 48px;
    height: 48px;
    border-radius: 48px;
    overflow: hidden;
    color: ${(props) => props.theme.color.white};
    background-color: ${(props) => props.theme.color.lavender};
    border: 4px solid ${(props) => props.theme.color.white};
    margin-left: ${(props) => (props.overlap ? '-28px' : '0')};
`;

const CSSTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const JRCModalUserList = ({
    open,
    usersList,
    title,
    handleLoadUsersList,
    setOpen,
    onClose,
}: JRCModalUserListProps) => {
    const doOnClose = useCallback(() => {
        setOpen(false);
        onClose();
    }, [onClose, setOpen]);

    return (
        <JRCModalLayout
            variant={'fixed-height'}
            maxHeight={'800px'}
            open={open}
            closeHandler={doOnClose}
            enableClickAwayCloseModal>
            <JRCModalContent
                overflow={'scroll'}
                onClickIconClose={doOnClose}
                title={
                    <CSSTitle>
                        <JRCIcon name="icon-user" size={24} color="black" />
                        {title}
                    </CSSTitle>
                }>
                <CSSUserList>
                    {usersList && (
                        <>
                            {usersList.data.map((user) => (
                                <CSSUserItem key={user.id} href={user._url}>
                                    <JRCTooltip description={user.title} position="left">
                                        <CSSAvatarWrapper>
                                            <JRCAvatar uri={user.uri} size={5} variant="circle" alt="" />
                                        </CSSAvatarWrapper>
                                    </JRCTooltip>
                                    <div>{user.title}</div>
                                </CSSUserItem>
                            ))}
                            {Math.ceil((usersList?.cnt ?? 0) / (usersList?.limit ?? 10)) > 1 && (
                                <JRCPagination
                                    activePage={usersList?.page ?? 1}
                                    nbrOfPage={Math.ceil((usersList?.cnt ?? 0) / (usersList?.limit ?? 10))}
                                    clickHandler={handleLoadUsersList}
                                />
                            )}
                        </>
                    )}
                </CSSUserList>
            </JRCModalContent>
        </JRCModalLayout>
    );
};
